import request from 'api/request';

export type NewsletterSignupParams = { email: string };
export type NewsletterSignupResponse = void;

export const newsletterSignup = async ({ email }: NewsletterSignupParams) => {
  return request<NewsletterSignupResponse>('POST', `newsletter-signup/`, { email });
};
